var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "BaseModal",
        {
          attrs: { id: "change-nickName-modal", "cancel-btn": "" },
          on: {
            clickConfirm: _vm.requestChangeNickName,
            clickCancel: function ($event) {
              return _vm.closeAlert("change-nickName-modal")
            },
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("modal.nickname.title"))),
          ]),
          _c("template", { slot: "content" }, [
            _c("div", { staticClass: "gap-rows" }, [
              _c("div", [
                _c("div", [_vm._v(_vm._s(_vm.$t("modal.nickname.content")))]),
                _c("div", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("modal.nickname.content1")) +
                      "\n          "
                  ),
                ]),
                _c("div", [_vm._v(_vm._s(_vm.$t("modal.nickname.content2")))]),
                _c("div", [_vm._v(_vm._s(_vm.$t("modal.nickname.content3")))]),
              ]),
              _c(
                "div",
                {
                  staticClass: "paragraph",
                  staticStyle: { "padding-right": "22px" },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("modal.nickname.content4"))),
                  ]),
                  _c("div", { staticClass: "sub" }, [
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("modal.nickname.content5"))),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.$t("modal.nickname.content6")) +
                          " " +
                          _vm._s(_vm.$t("modal.nickname.content7"))
                      ),
                    ]),
                    _c("p", [
                      _vm._v(_vm._s(_vm.$t("modal.nickname.content8"))),
                    ]),
                  ]),
                ]
              ),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("modal.nickname.content9")),
                },
              }),
            ]),
            _c("div", { attrs: { id: "nickname-input-field" } }, [
              _c("div", { staticClass: "d-grid" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nickName,
                      expression: "nickName",
                    },
                  ],
                  staticClass: "mt-3",
                  class: {
                    validations: _vm.validationText !== "",
                    true: _vm.isNotDuplicated,
                  },
                  attrs: {
                    type: "text",
                    maxlength: "10",
                    placeholder: _vm.$t("modal.nickname.placeholder"),
                  },
                  domProps: { value: _vm.nickName },
                  on: {
                    focus: _vm.checkProfanity,
                    blur: _vm.resetInput,
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.nickName = $event.target.value
                    },
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "mt-3 duplicate-check",
                    on: { click: _vm.duplicateCheck },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("modal.nickname.duplicatecheck")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "validation nickname",
                  class: `${_vm.isNotDuplicated}`,
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t(_vm.validationText)) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
          _c("template", { slot: "confirm" }, [
            _vm._v(_vm._s(_vm.$t("modal.nickname.confirm"))),
          ]),
        ],
        2
      ),
      _c(
        "BaseModal",
        {
          attrs: { id: "change-nickName-success-modal", "cancel-btn": "" },
          on: {
            clickCancel: function ($event) {
              return _vm.closeAlert("change-nickName-success-modal")
            },
            clickConfirm: _vm.newCommunity,
          },
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("modal.nickname.title"))),
          ]),
          _c("template", { slot: "content" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.$t("modal.nickname.success.content"))
            ),
            _c("br"),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("modal.nickname.success.content1")) +
                "\n    "
            ),
          ]),
          _c("template", { slot: "confirm" }, [
            _vm._v(_vm._s(_vm.$t("modal.nickname.success.confirm"))),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }